export default __webpack_public_path__ + "static/media/img_noData_google.599dd77e.svg";